var exports = {
  "i": "x31de4314--4f560f--wrapper",
  "x": "x31de4314--4f560f--button",
};

module.exports = exports;
